import axios from "axios";

const endpoint_url = "/message/whatsappOtpReport/otpReport";

const otpReport = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url
        , {
          params: {
            length: parameters.length,
            start: parameters.start,
            search: parameters.search,
            order: parameters.order,
            order_by: parameters.orderBy,
            registered_date: parameters.registeredDate,
            verified_date: parameters.verifiedDate
          }
        }
      )
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default otpReport;
